import { cn } from '@gymcoach/ui';

/** "Iron House" → "IH"; "Pulse Fitness" → "PF"; "The Gym Spot" → "S"; "GymCoach" → "G". */
export function monogramFor(name: string): string {
  const words = name.split(/\s+/).filter((word) => word && !/^(gym|the|&|and)$/i.test(word));
  const source = words.length > 0 ? words : name.split(/\s+/).filter(Boolean);
  return (
    source
      .slice(0, 2)
      .map((word) => word[0]!.toUpperCase())
      .join('') || 'G'
  );
}

/**
 * The gym's mark: its logo when it has one, else its initials on the brand colour.
 * The gym's name sits beside it, so the mark itself is decorative (aria-hidden).
 */
export function GymMark({
  name,
  logoUrl,
  showName = true,
  className,
}: {
  name: string;
  logoUrl?: string | null;
  showName?: boolean;
  className?: string;
}) {
  return (
    <div className={cn('flex min-w-0 items-center gap-2.5', className)}>
      {logoUrl ? (
        <img src={logoUrl} alt="" className="h-9 w-9 shrink-0 rounded-sm object-cover" aria-hidden="true" />
      ) : (
        <span
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-sm bg-primary text-sm font-bold tracking-wide text-primary-ink"
          aria-hidden="true"
        >
          {monogramFor(name)}
        </span>
      )}
      {showName && <span className="truncate text-base font-semibold text-ink">{name}</span>}
    </div>
  );
}
